export const UHSDomainList = [
  'horizonhealth.com',
  'uhsinc.com',
  'frnmail.com',
  'healthlinknow.com',
  'nwths.com',
  'thcs.org',
  'uhsrgv.com',
];
